import React from 'react';
import TheralyticsLoginLogo from './svglogos/LoginLogo/TheralyticsLogo';
import AIPLoginLogo from './svglogos/LoginLogo/AipLogo'; 
import NEABALogo from './svglogos/LoginLogo/NEABALogo'; 
import BESTABALogo from './svglogos/LoginLogo/BESTABALogo'; 
import BuildABlockLogo from './svglogos/LoginLogo/BuildABlockLogo'; 
import VillageLearningLoginLogo from './svglogos/LoginLogo/VillageLearningLogo';
import UPLUSLogo from './svglogos/LoginLogo/UPLUSLogo'; 
import AdAstraLogo from './svglogos/LoginLogo/AdAstraLogo'; 
// import TheralyticsInnerLogo from './svglogos/InnerLogo/TheralyticsLogo'; 
import TheralyticsInnerLogo from './svglogos/InnerLogo/TheralyticsLogoWhite'; 
// import AIPInnerLogo from './svglogos/InnerLogo/AipLogo'; 
import AIPInnerLogo from './svglogos/InnerLogo/AipLogoWhite'; 
import NEABAInnerLogo from './svglogos/InnerLogo/NEABALogo'; 
import BESTABAInnerLogo from './svglogos/InnerLogo/BESTABALogoWhite';
import VillageLearningInnerLogo from './svglogos/InnerLogo/VillageLearningLogoWhite';
import UPLUSLogoInnerLogo from './svglogos/InnerLogo/UPLUSLogoWhite';
import AdAstraLogoInnerWhite from './svglogos/InnerLogo/AdAstraLogoWhite';
import { ADASTRA } from '../actions/utilAction';
// import BuildABlockInnerLogo from './svglogos/InnerLogo/BuildABlockLogoWhite'; 

const LogoImageViewer = (props) => {
    const {
        logoUrl,
        isLoginPage,
        businessName,
    } = props;

    if (businessName && businessName.toUpperCase() === 'AIP') {
        return (
            isLoginPage ? <AIPLoginLogo /> : <AIPInnerLogo />
        )
    }
    else if (businessName && businessName.toUpperCase() === 'NE-ABA') {
        return (
            isLoginPage ? <NEABALogo /> : <NEABAInnerLogo />
        )
    } 
    else if (businessName && businessName.toUpperCase() === 'BESTABA') {
        return (
            isLoginPage ? <BESTABALogo /> : <BESTABAInnerLogo />
        )
    } 
    // else if (businessName && businessName.toUpperCase() === 'BUILDABLOCKTHERAPY') {
    //     return (
    //         isLoginPage ? <BuildABlockLogo /> : <BuildABlockInnerLogo />
    //     )
    // }    
    else if (businessName && businessName.toUpperCase() === 'BUILDABLOCKTHERAPY') {
        return (
            isLoginPage ? <BuildABlockLogo /> : <TheralyticsInnerLogo />
        )
    }   
    else if (businessName && businessName.toUpperCase() === 'VILLAGELEARNING') {
        return (
            isLoginPage ? <VillageLearningLoginLogo /> : <VillageLearningInnerLogo />
        )
    }   
    else if (businessName && businessName.toUpperCase() === 'UPLUS') {
        return (
            isLoginPage ? <UPLUSLogo /> : <UPLUSLogoInnerLogo />
        )
    } 
    else if (businessName && businessName.toUpperCase() === ADASTRA) {
        return (
            isLoginPage ? <AdAstraLogo /> : <AdAstraLogoInnerWhite />
        )
    } 
    else {
        return (
            isLoginPage ? <TheralyticsLoginLogo /> : <TheralyticsInnerLogo/>
        )
    }
    // if (!logoUrl) {
    //     return (
    //         isLoginPage ? <TheralyticsLoginLogo /> : <TheralyticsInnerLogo/>
    //     )
    // }
    return (
        <img src={logoUrl} alt="" />
    )
}

export default LogoImageViewer;



// WEBPACK FOOTER //
// ./src/components/logoImageViewer.js